<template>
  <section
    id="maksutapa"
    class="section"
  >
    <template>
      <h2 class="section__heading section__heading--alt2">
        4. {{ $modeoL10n.payment_method }}
      </h2>

      <div class="checkout__rows">
        <div class="checkout__header">
          <label class="checkout__header__field">
            <input
              v-model="selectedPaymentMethod"
              type="radio"
              name="payment_method"
              value="paytrail"
              class="radio-input"
              @change="paymentMethodChanged()"
            >
            <span class="checkout__header__heading radio-label">{{ $modeoL10n.payment_method_checkoutfi }}</span>
          </label>
        </div>

        <div
          v-if="selectedPaymentMethod=='paytrail'"
          class="checkout__subsection checkout__subsection--payment"
        >
          <ul class="checkout__payment-types">
            <li
              v-for="type, index in getPaymentTypes()"
              :key="index"
            >
              <span>
                {{ type.title }}<br>
                <span class="checkout__payment-description">{{ type.description }}</span>
              </span>
              <span class="checkout__payment-providers">
                <template v-for="provider in type.providers">
                  <span
                    :key="provider.slug"
                    :class="[ 'checkout__payment-logo', 'checkout__payment-logo--' + provider.slug ]"
                  >
                    <span class="screen-reader-text">{{ provider.name }}</span>
                  </span>
                </template>
              </span>
            </li>
          </ul>
        </div>

        <div class="checkout__header">
          <label class="checkout__header__field">
            <input
              v-model="selectedPaymentMethod"
              type="radio"
              name="payment_method"
              value="klarna_payments"
              class="radio-input"
              @change="paymentMethodChanged()"
            >
            <span class="checkout__header__heading radio-label">{{ $modeoL10n.payment_method_klarna }}</span>
          </label>
        </div>

        <div
          v-if="selectedPaymentMethod=='klarna_payments'"
          class="checkout__subsection checkout__subsection--payment"
        >
          <ul class="checkout__payment-types">
            <li
              v-for="type, index in getKlarnaPaymentTypes()"
              :key="index"
            >
              <span>
                {{ type.title }}<br>
                <span class="checkout__payment-description">{{ type.description }}</span>
              </span>
              <span class="checkout__payment-providers">
                <template v-for="provider in type.providers">
                  <span
                    :key="provider.slug"
                    :class="[ 'checkout__payment-logo', 'checkout__payment-logo--' + provider.slug ]"
                  >
                    <span class="screen-reader-text">{{ provider.name }}</span>
                  </span>
                </template>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </template>

    <section class="section">
      <div
        v-show="errors.has('termsAndConditions')"
        class="error-notification"
      >
        {{ errors.first('termsAndConditions') }}
      </div>
      <div class="checkout__rows">
        <div class="checkout__header">
          <label class="checkbox">
            <input
              id="termsAndConditions"
              v-model="termsAndConditions"
              v-validate="'required'"
              class="checkbox-input"
              type="checkbox"
              name="termsAndConditions"
              @change="fieldChanged()"
              @keydown.enter.prevent
            >
            <span class="checkout__header__heading checkbox-label checkbox-label--last">{{ $modeoL10n.terms }} *</span>
            <a
              class="checkout__header__link"
              :href="$modeoL10n.terms_link"
              target="_blank"
            >{{ $modeoL10n.terms_link_text }}</a>
          </label>
        </div>
      </div>
    </section>

    <div class="woocommerce-checkout-payment">
      <div class="form-row place-order">
        <div class="checkout__button__container checkout__button__container--back">
          <a
            class="checkout__button checkout__button--back btn btn--secondary btn--block"
            :href="$modeoL10n.url_shop"
          >{{ $modeoL10n.return_to_shop }}</a>
        </div>

        <div class="checkout__button__container">
          <div>
            <button
              type="submit"
              class="checkout__button btn btn--block"
              :name="formName"
              @click="submit()"
            >
              {{ $modeoL10n.proceed_to_payment }}
              <!-- don't use <price> here -->
              <template>
                {{ total | formatPrice }}
              </template>
            </button>
          </div>
          <div
            v-show="sectionsWithErrors.length > 0"
            class="checkout__errors"
          >
            {{ $modeoL10n.errors_in_form }} {{ $modeoL10n.errors_in_checkout_form }}
            <a
              v-for="(section, index) in sectionsWithErrors"
              :key="section.id"
              :href="'#' + section.id"
            >{{ section.label }}<span v-if="index < (sectionsWithErrors.length - 1)">, </span></a>.
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
    import { EventBus } from '../../event-bus.js';
    import _ from 'lodash';

    export default {
        data : function () {
            return {
                selectedPaymentMethod: 'paytrail',
                termsAndConditions: false,
                paymentMethods: {
                    paytrail: { label: this.$modeoL10n.payment_method_checkoutfi, key: 'paytrail' },
                    klarna_payments: { label: this.$modeoL10n.payment_method_klarna, key: 'klarna_payments' },
                },
                sections: {
                    'billing': {
                        'label': this.$modeoL10n.checkout_section_billing_address,
                        'id': 'billing-form',
                    },
                    'shipping': {
                        'label': this.$modeoL10n.checkout_section_shipping_address,
                        'id': 'shipping-form',
                    },
                    'shipping-method': {
                        'label': this.$modeoL10n.checkout_section_shipping_method,
                        'id': 'shipping-method',
                    },
                },
            };
        },
        computed: {

            total: function() {
                return this.$store.getters.getTotalIncludingShipping;
            },

            formName : function() {
                if (this.selectedPaymentMethod !== 'klarna_payments') {
                  return 'woocommerce_checkout_place_order';
                } else {
                  return '';
                }
            },

            sectionsWithErrors : function() {
                let values = _.values(this.errorsInSections);

                let keys = _.keys(this.errorsInSections).filter( (sectionKey, index) => {
                    if (values[index]) {
                        return true
                    }
                });

                return keys.map( sectionKey => {
                    return this.sections[sectionKey];
                })
            },
            errorsInBillingForm : function() {
                return !this.$store.getters.getBillingAddress.valid;
            },
            errorsInShippingForm : function() {
                return !this.$store.getters.getShippingAddress.valid;
            },
            errorsInShippingMethod : function() {
                if (!this.$store.getters.getShippingMethod) {
                    return true;
                }
                return false;
            },
            errorsInSections : function() {
                let errors = {};
                errors.billing = this.errorsInBillingForm;
                errors.shipping = this.errorsInShippingForm;
                errors['shipping-method'] = this.errorsInShippingMethod;
                return errors;
            },
            shippingMethod : function() {
                return this.$store.getters.getShippingMethod
            },


        },
        created: function () {
            this.paymentMethodChanged();
            this.termsAndConditions = this.$store.getters.getTermsAndConditions;
        },
        methods: {
            paymentMethodChanged: function() {
                this.$store.commit('setPaymentMethod', this.paymentMethods[this.selectedPaymentMethod]);
            },

            fieldChanged: function() {
                this.$validator.validate('termsAndConditions');
                this.$store.commit( 'setTermsAndConditions', this.termsAndConditions);
            },

            submit: function() {
                this.$validator.validateAll().then( ( result ) => {
                    this.$store.commit( 'setCheckoutSubmitClicked', true );
                    if ( this.sectionsWithErrors.length > 0 ) {
                        event.preventDefault();
                        EventBus.$emit( 'checkout-page-submit-clicked', true );
                        this.scrollToFirstError();
                    }
                    if ( !result ) {
                        event.preventDefault();
                    }
                });

            },

            scrollToFirstError: function() {
                if (this.sectionsWithErrors.length > 0) {
                    var formErrorsTop = document.getElementById(this.sectionsWithErrors[0].id).offsetTop;
                    window.scrollTo( 0, formErrorsTop - 30);
                }

            },

            allowInvoice: function() {
              return window.location.host.indexOf('kukkapuro') !== -1;
            },

            getPaymentTypes: function() {
              const paymentTypes = [
                {
                  title: this.$modeoL10n.payment_online,
                  providers: [
                    { slug: 'op', name: 'OP' },
                    { slug: 'nordea', name: 'Nordea' },
                    { slug: 'handelsbanken', name: 'Handelsbanken' },
                    { slug: 'poppankki', name: 'POP Pankki' },
                    { slug: 'aktia', name: 'Aktia' },
                    { slug: 'alandsbanken', name: 'Ålandsbanken' },
                    { slug: 'omasp', name: 'Oma Säästöpankki' },
                    { slug: 'spankki', name: 'S-Pankki' },
                    { slug: 'saastopankki', name: 'Säästöpankki' },
                    { slug: 'danskebank', name: 'Danske Bank' },
                  ],
                },
                {
                  title: this.$modeoL10n.payment_card,
                  providers: [
                    { slug: 'visa', name: 'Visa' },
                    { slug: 'visaelectron', name: 'Visa Electron' },
                    { slug: 'mastercard', name: 'Mastercard' },
                  ],
                },
                {
                  title: this.$modeoL10n.payment_mobile,
                  providers: [
                    { slug: 'pivo', name: 'Pivo' },
                    { slug: 'mobilepay', name: 'MobilePay' },
                  ],
                },
              ];

              /*
              const allowInvoice = window.location.host.indexOf('kukkapuro') !== -1;

              if (allowInvoice) {
                paymentTypes.push(
                  {
                    title: this.$modeoL10n.payment_invoice,
                    description: this.$modeoL10n.payment_description_invoice,
                    providers: [
                      { slug: 'oplasku', name: 'OP Lasku' },
                    ],
                  },
                );
              }
              */

              return paymentTypes;
            },
            
            getKlarnaPaymentTypes: function() {
              const paymentTypes = [
                {
                  title: this.$modeoL10n.klarna,
                  providers: [
                    { slug: 'klarna', name: 'Klarna' },
                  ],
                },
              ];

              return paymentTypes;
            },
        },
    }
</script>
